<template>
  <ul>
    <li v-for="node in nodes" :key="node.id">
      <div class="model-alias-item">
        <div class="model-alias-column">
          <ins>{{ node.label }}</ins>
        </div>
        <div class="model-alias-column">
          <a-form-model-item
            :label="null"
            :prop="node.devModelId"
            v-if="isEdit"
            style="margin-bottom: 0;"
          >
            <a-input
              v-model="form[node.devModelId]"
              :placeholder="$t('deviceModel_alias_name_placeholder')"
              @change="event => formChange(event, node.devModelId)"
              allowClear
            />
          </a-form-model-item>
          <span v-else>{{ node.alias || '-' }}</span>
        </div>
      </div>

      <!-- 如果存在子节点，递归渲染 -->
      <tree-node
        v-if="node.children"
        :nodes="node.children"
        :isEdit="isEdit"
        :form="form"
        @change="formChange"
        v-bind="$attrs"
        v-on="$listeners"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'TreeNode',
  props: {
    nodes: {
      type: Array,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formChange(event, key) {
      this.$set(this.form, key, event.target.value);
    },
  },
};
</script>
<style lang="less" scoped>
.model-alias-column {
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
